import type { ReactNode } from 'react';
import { Group, Stack, Text, Title } from '@mantine/core';

export function PageHeader({
  title,
  description,
  actions,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <Stack gap={4} mb="md">
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="sm">
        <Title order={1}>{title}</Title>
        {actions && <Group gap="xs">{actions}</Group>}
      </Group>
      {description && (
        <Text size="sm" c="dimmed">
          {description}
        </Text>
      )}
      {children}
    </Stack>
  );
}
